import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcSave(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 2.75a.75.75 0 0 1 .75.75v10.337l2.66-2.661a.75.75 0 0 1 1.062 1.06l-3.942 3.942a.75.75 0 0 1-1.06 0l-3.941-3.942a.75.75 0 1 1 1.06-1.06l2.661 2.66V3.5a.75.75 0 0 1 .75-.75"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.75 15a.75.75 0 0 1 .75.75v3.5c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25v-3.5a.75.75 0 0 1 1.5 0v3.5A2.75 2.75 0 0 1 18.25 22H5.75A2.75 2.75 0 0 1 3 19.25v-3.5a.75.75 0 0 1 .75-.75"
  }));
}
var IcSave = createNolIcon(/*#__PURE__*/forwardRef(SvgIcSave));

export { IcSave as I };
